import type { Dispatch } from '@reduxjs/toolkit';
import { fetchAuthSession } from 'aws-amplify/auth';
import { jwtDecode } from 'jwt-decode';
import { clearClaims, setClaims } from 'store/slices/claimsSlice';

import { extractClaimsFromPayload } from './extractClaims';
import type { TokenPayload } from './tokenTypes';

export const initClaims = async (dispatch: Dispatch) => {
    try {
        const session = await fetchAuthSession();
        const accessToken = session.tokens?.accessToken?.toString();

        if (!accessToken) {
            dispatch(clearClaims());
            return;
        }

        const decoded = jwtDecode<TokenPayload>(accessToken.toString());
        const claims = extractClaimsFromPayload(decoded);

        dispatch(setClaims(claims));
    } catch {
        dispatch(clearClaims());
    }
};
